import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Badge as MuiBadge } from "@material-ui/core";
import { CancelRounded, ErrorRounded, Info, PanoramaFishEye } from "@material-ui/icons";

import buildAssetsUrl from "../../../../util/strings/buildAssetsUrl";
import { vehicleHistoryStyles } from "./sharedStyles";

export const Badge = React.forwardRef(({ type, count, showZero }, ref) => {
  const theme = useTheme();

  let color;
  let icon;

  switch (type) {
    case "fault": {
      color = theme.palette.error[theme.palette.type];
      icon = <CancelRounded htmlColor={color} />;
      break;
    }
    case "hazard": {
      color = theme.palette.warning[theme.palette.type];
      icon = <ErrorRounded htmlColor={color} />;
      break;
    }
    case "debug": {
      color = theme.palette.text.primary;
      icon = <PanoramaFishEye htmlColor={color} />;
      break;
    }
    case "warning":
    case "info":
    case "timelineGraphic":
    case "notice": {
      color = theme.palette.text.primary;
      icon = <Info htmlColor={color} />;
      break;
    }
    default: {
      const path = buildAssetsUrl("VehicleHistoryMap/icons");
      icon = <img src={`${path}/${type}.svg`} alt={type} />;
    }
  }

  const classes = makeStyles(() => ({
    badgeContent: {
      color,
      fontWeight: "bolder",
      fontSize: "14px",
      transform: "scale(1) translate(25%, -25%)",
    },
    badgeContainer: {
      paddingTop: "12px",
      paddingLeft: "12px",
    },
  }))();

  return (
    <MuiBadge
      innerRef={ref}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      badgeContent={(count || showZero) && <div className={classes.badgeContent}>{count}</div>}
    >
      {icon}
    </MuiBadge>
  );
});

const StatusType = PropTypes.oneOf([
  "fault",
  "hazard",
  "warning",
  "notice",
  "info",
  "debug",
  "tripInfo",
  "tripStart",
  "tripEnd",
  "timelineGraphic",
]);

Badge.propTypes = {
  type: StatusType.isRequired,
  count: PropTypes.number,
  showZero: PropTypes.bool,
};

Badge.defaultProps = {
  count: 0,
  showZero: false,
};

const useVehicleHistoryStyles = makeStyles(vehicleHistoryStyles);

const VehicleTimelineBadges = ({ events }) => {
  const faults = events.filter(({ type }) => type === "fault");
  const hazards = events.filter(({ type }) => type === "hazard");
  const classes = useVehicleHistoryStyles();

  return (
    <div className={classes.badges}>
      {faults.length > 0 && <Badge type="fault" />}
      {hazards.length > 0 && <Badge type="hazard" />}
    </div>
  );
};

VehicleTimelineBadges.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default VehicleTimelineBadges;
